import {
  Box, Typography, styled,
} from '@material-ui/core';

export const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: '100vh',
});

export const HeaderBox = styled(Box)({
  marginTop: 32,
  marginBottom: 8,
});

export const Title = styled(Typography)({
  marginBottom: 8,
});

export const ConsentRow = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 12,
  marginTop: 8,
  marginBottom: 24,
});

export const ConsentCheckbox = styled('input')({
  marginTop: 2,
  flexShrink: 0,
  width: 18,
  height: 18,
  cursor: 'pointer',
});

export const ConsentText = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.text.primary,
  lineHeight: 1.5,
}));

export const ConsentLink = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'underline',
  cursor: 'pointer',
}));

export const SubmitButtonBox = styled(Box)({
  marginTop: 8,
});
